module.exports = __webpack_public_path__ + "media/images/lb/034-4466c8f76df63d6788ad1f2c2ceef648.svg";